/* This file is generated by createIcons.js any changes will be lost. */
import createIcon from '../createIcon';

var BackwardIcon = createIcon({
  name: 'BackwardIcon',
  height: 512,
  width: 512,
  svgPath: 'M11.5 280.6l192 160c20.6 17.2 52.5 2.8 52.5-24.6V96c0-27.4-31.9-41.8-52.5-24.6l-192 160c-15.3 12.8-15.3 36.4 0 49.2zm256 0l192 160c20.6 17.2 52.5 2.8 52.5-24.6V96c0-27.4-31.9-41.8-52.5-24.6l-192 160c-15.3 12.8-15.3 36.4 0 49.2z',
  yOffset: '',
  xOffset: '',
  transform: ''
});

export default BackwardIcon;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@patternfly/react-icons/dist/esm/icons/backward-icon.js
// module id = 363
// module chunks = 0